import { Switch, Tooltip } from 'antd';
import axios from 'axios';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useMutation } from 'react-query';

import apiRoutes from '../app/apiRoutes';
import { useBoardData, useBoardSelfRights } from '../app/contexts/BoardContext';
import { queryClient } from '../appSingletons';
import { axiosToQueryFn } from '../common/utils/httpUtils';
import styles from '../styles/pages/BoardDetailPage.module.less';

const fetchSetOwnCardsOnly = axiosToQueryFn(({ boardId, ownCardsOnly }) =>
  axios.post(apiRoutes.setBoardOwnCardsOnly(boardId), { ownCardsOnly })
);

export default function OwnCardsOnlyToggle({ boardId }) {
  const { ownCardsOnly } = useBoardData();
  const { moderatorRight } = useBoardSelfRights();
  const { mutate: setOwnCardsOnly, isLoading } = useMutation({
    mutationFn: fetchSetOwnCardsOnly,
    mutationKey: ['setBoardOwnCardsOnly', { boardId }],
    onSuccess: async () => {
      await queryClient.refetchQueries('board');
    },
  });

  if (!moderatorRight) {
    return null;
  }

  return (
    <Tooltip title={<FormattedMessage id="board.ownCardsOnly.tooltip" />}>
      <div
        className={classNames('ant-btn', styles.OwnCardsOnly)}
        onClick={() => {
          if (isLoading) {
            return;
          }
          setOwnCardsOnly({ boardId, ownCardsOnly: !ownCardsOnly });
        }}
      >
        <span>
          <FormattedMessage id="board.ownCardsOnly.label" />
        </span>
        <Switch checked={ownCardsOnly} loading={isLoading} />
      </div>
    </Tooltip>
  );
}
